export default "__VITE_ASSET__Dc05Tj$R__"